import { subscriptionList as EnUsSubscriptionList } from '../en-us/subscriptionList';
import { AgResourceLanguage } from '../types';

export const subscriptionList: AgResourceLanguage['subscriptionList'] = {
  ...EnUsSubscriptionList,
  showCheckboxLabel: 'Toon alleen actieve abonnementen',
  emptyState: {
    ...EnUsSubscriptionList.emptyState,
    title: 'Maak je eerste abonnement aan',
    text: `Het lijkt erop dat je nog geen aankoop hebt gedaan. Krijg volledige ondersteuning voor voeding en darmgezondheid in één simpele schep.`,
    button: 'Haal Je AG1'
  },
  subscriptionCard: {
    ...EnUsSubscriptionList.subscriptionCard,
    titleOrder: 'Volgende Bestelling:',
    titleSubscription: 'Abonnementsproducten:',
    activeLabel: 'Actief',
    cancelLabel: 'Geannuleerd',
    frequencyTitle: 'Frequentie:',
    frequencyDayText: 'Elke',
    manageSubscriptionButton: 'Abonnement Beheren',
    subscriptionDetailsButton: 'Abonnementsdetails',
    reactivateButton: 'Heractiveren',
    orderDateLabel: 'Besteldatum:',
    orderTotalLabel: 'Besteltotaal:',
    productsSubtitle: 'Producten:',
    subscriptionDetailsSubtitle: 'Abonnementsdetails'
  },
  cancelList: {
    ...EnUsSubscriptionList.cancelList,
    title: 'Geannuleerde Abonnementen',
    description: `Heractiveer je abonnement om AG1 volgens jouw schema te ontvangen. Zodra je abonnement actief is, kun je je voorkeuren aanpassen en het volledige assortiment AG1-producten shoppen.`
  }
};
